var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "33px",
    viewBox: "0 0 40 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share-outside-Sekeron---Done",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sharing-any-post-outside-sekeron-171",
    transform: "translate(-716, -796)",
    fill: "#03A9F4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(676, 380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(0, 30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(0, 74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(0, 76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-(1)",
    transform: "translate(40, 236.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3846154,3.78830769 C37.92,4.43076923 36.3593846,4.85661538 34.7323077,5.06338462 C36.4061538,4.064 37.6836923,2.49353846 38.2843077,0.600615385 C36.7236923,1.53107692 35.0006154,2.18830769 33.1643077,2.55507692 C31.6824615,0.977230769 29.5704615,0 27.2664615,0 C22.7963077,0 19.1975385,3.62830769 19.1975385,8.07630769 C19.1975385,8.71630769 19.2516923,9.33169231 19.3846154,9.91753846 C12.672,9.59015385 6.73230769,6.37292308 2.74215385,1.472 C2.04553846,2.68061538 1.63692308,4.064 1.63692308,5.55323077 C1.63692308,8.34953846 3.07692308,10.8283077 5.22338462,12.2633846 C3.92615385,12.2387692 2.65353846,11.8621538 1.57538462,11.2689231 C1.57538462,11.2935385 1.57538462,11.3255385 1.57538462,11.3575385 C1.57538462,15.2812308 4.37415385,18.5403077 8.04430769,19.2910769 C7.38707692,19.4707692 6.67076923,19.5569231 5.92738462,19.5569231 C5.41046154,19.5569231 4.88861538,19.5273846 4.39876923,19.4190769 C5.44492308,22.6166154 8.41353846,24.9673846 11.9433846,25.0436923 C9.19630769,27.1926154 5.70830769,28.4873846 1.93230769,28.4873846 C1.27015385,28.4873846 0.635076923,28.4578462 0,28.3766154 C3.57661538,30.6830769 7.81538462,32 12.3864615,32 C27.2443077,32 35.3673846,19.6923077 35.3673846,9.024 C35.3673846,8.66707692 35.3550769,8.32246154 35.3378462,7.98030769 C36.9403077,6.84307692 38.2867692,5.42276923 39.3846154,3.78830769 Z",
    id: "Path"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitter);
export default __webpack_public_path__ + "static/media/ic_twitter.0e812196b955ea5524608d8553b667dc.svg";
export { ForwardRef as ReactComponent };